import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=47f8e31a&"
import script from "./AppBody.vue?vue&type=script&lang=js&"
export * from "./AppBody.vue?vue&type=script&lang=js&"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=47f8e31a&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports